import get from 'lodash/get';

const createErrorMediaData = error => {
  const { message } = get(error, 'graphQLErrors[0]', error);

  let errorVideoSource;
  let errorVideoTitle;

  switch (true) {
    default:
      errorVideoSource = process.env.REACT_APP_FALLBACK_VIDEO;
      errorVideoTitle = 'Er is iets fout gegaan met de video.';
      break;

    case message.includes('timeslot_not_eight_pm_until_six_am'):
      errorVideoSource = process.env.REACT_APP_FALLBACK_VIDEO_20;
      errorVideoTitle =
        'Deze video is alleen te bekijken tussen 20:00 uur en 06:00 uur vanwege een leeftijdsbeperking';
      break;

    case message.includes('timeslot_not_ten_pm_until_six_am'):
      errorVideoSource = process.env.REACT_APP_FALLBACK_VIDEO_22;
      errorVideoTitle =
        'Deze video is alleen te bekijken tussen 22:00 uur en 06:00 uur vanwege een leeftijdsbeperking';
      break;
  }

  return {
    play: true,
    title: errorVideoTitle,
    type: 'video',
    source: [
      {
        name: 'HD',
        type: 'video/mp4',
        ratio: '16:9',
        src: errorVideoSource,
      },
    ],
  };
};

export default createErrorMediaData;
